import styled, { css } from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 870px;
  padding: 0 0 100px 0;
  width: 100%;

  ${(props: { full?: boolean }) =>
    props.full &&
    css`
      padding: 0;
      height: 100vh;
    `}
`;
